<template>
  <el-container class="m-works">
    <div
      style="height: 46px; text-align: center;font-weight: 500; font-size: 24px; padding-top: 18px;background: #ffffff;"
    >
      {{ type === 'my' ? '我的作品' : type === 'team' ? '团队作品' : '' }}
    </div>
    <top
      ref="top"
      :selectList="selectList"
      :condition="param"
      :projectId="projectId"
      :loading="loadingDelete"
      @exportImgs="exportImgs"
      @toggleCheckAll="toggleCheckAll"
      @deleteWorks="deleteMoreWorks"
      @submitSearch="submitSearch"
    ></top>
    <el-main
      :style="getWidth()"
      class="items-container"
      v-loading.lock="loading"
      element-loading-background="rgba(256,256,256, 0.65)"
      element-loading-text="拼命加载中, 请稍候"
      element-loading-spinner="el-icon-loading"
    >
      <div :style="getListStyle()">
        <div
          class="m-item"
          :span="4"
          v-for="(item, index) in items"
          :key="item.id"
        >
          <div class="m-box">
            <span
              class="del-tag c-tip"
              v-if="
                isTeamTemplate(item.type) &&
                  item.deletedLinkedTemplateIds &&
                  item.deletedLinkedTemplateIds.length > 0
              "
              >模板已删除</span
            >
            <div class="item-box">
              <span class="template-icon tpl-group-icon" v-if="isPPT(item.type)"
                ><i class="icon"></i>PPT</span
              >
              <span
                class="template-icon tpl-group-icon"
                v-if="isMulti(item.type)"
                ><i class="icon"></i>图文</span
              >
              <img :src="item.url + '?imageView&thumbnail=200x0'" />
              <div class="mask" :class="item.check ? 'active' : ''">
                <i
                  @click.stop="toggleCheck(item, $event)"
                  class="checkbox iconfont"
                  :class="
                    item.check
                      ? 'active icon-check-checked'
                      : 'icon-check-hover'
                  "
                ></i>
                <div class="opration">
                  <div
                    class="template-icon-btn tpl-edit-icon"
                    @click.stop="editWorkOnImg(item)"
                  >
                    <i class="icon myico-edit"></i>
                    <div>编辑</div>
                  </div>
                  <el-popover
                    trigger="click"
                    placement="bottom"
                    popper-class=""
                    v-model="item.exportVisible"
                  >
                    <div style="margin: 15px 40px">
                      <p>请选择导出格式：</p>
                      <p>
                        <el-radio-group v-model="fileType">
                          <el-radio label="png">PNG</el-radio>
                          <el-radio label="jpg">JPG</el-radio>
                        </el-radio-group>
                      </p>
                    </div>
                    <div style="text-align: right; margin: 0">
                      <el-button @click="item.exportVisible = false" size="mini"
                        >取消</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="
                          item.exportVisible = false
                          exportOneImg(item, fileType)
                        "
                        >确定</el-button
                      >
                    </div>
                    <div
                      class="template-icon-btn tpl-edit-icon"
                      slot="reference"
                    >
                      <i class="icon el-icon-bottom"></i><span>导出</span>
                    </div>
                  </el-popover>
                  <div
                    class="template-icon-btn tpl-use-icon"
                    @click.stop="previewWork(index, item)"
                  >
                    <i class="icon"></i>
                    <div>预览</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="works-item-footer">
              <el-popover
                popper-class="no-arrow"
                placement="right-start"
                trigger="hover"
                visible-arrow="false"
              >
                <ul>
                  <li @click="handleTagWork(item)">标签分类</li>
                  <li @click="copyWork(item)" v-if="isNotStudyCP">复制作品</li>
                  <li
                    @click="shareWork(item)"
                    v-if="
                      (type === 'my' || item.author == userInfo.id) &&
                        isNotStudyCP
                    "
                  >
                    分享作品
                  </li>
                  <li @click="copyUrl(item)" v-if="isNotStudyCP">复制链接</li>
                  <el-popover
                    placement="bottom-end"
                    popper-class="c-delete-propper delete-propper-work"
                    v-model="item.visible1"
                  >
                    <p><i class="el-icon-warning"></i>你确认要删除该作品吗？</p>
                    <div style="text-align: right; margin: 0">
                      <el-button @click="item.visible1 = false">取消</el-button>
                      <el-button
                        type="primary"
                        @click="
                          item.visible1 = false
                          deleteOneWork(item)
                        "
                        >确定</el-button
                      >
                    </div>
                    <li
                      slot="reference"
                      v-if="type === 'my' || item.author == userInfo.id"
                    >
                      删除
                    </li>
                  </el-popover>
                </ul>
                <div class="item-menu" slot="reference">
                  <i class="el-icon-more"></i>
                </div>
              </el-popover>
              <div class="item-name" :class="{ active: item.isNameEdit }">
                <span
                  v-show="!item.isNameEdit"
                  :title="item.name"
                  v-html="item.nameShow"
                  @click="editName(item, index)"
                ></span>
                <input
                  class="item-name-input"
                  @blur="clickout(item, index)"
                  v-show="item.isNameEdit"
                  type="text"
                  :value="item.name"
                  :ref="'editArea' + index"
                />
                <i
                  v-show="!item.isNameEdit"
                  class="el-icon-edit"
                  @click="editName(item, index)"
                ></i>
              </div>
              <div class="item-size-time">
                <div class="item-size" v-if="item.json">
                  {{ item.widthHeight }}
                </div>
                <div class="item-time" v-if="type === 'team'">
                  {{ item.authorName }}
                </div>
                <div class="item-time">{{ item.relativeUpdateTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <noResult
        v-show="!items.length && !loading"
        class="noResult"
        :searchContent="searchContent"
        :param="param"
        @getAllData="getAllData"
      >
      </noResult>
      <self-carsoursel
        v-if="worksPreview"
        v-model="worksPreview"
        :index="current"
        :data="items"
        :key="2"
        @switch="onSwitchPng"
      >
        <div slot="bottom" slot-scope="props" class="m-preview-bottom">
          <div class="opration">
            <el-button
              type="primary"
              round
              @click="exportImgsForPreview(props.data)"
              >导出</el-button
            >
            <el-button
              type="primary"
              round
              @click="editWorkOnPreview(props.data)"
              >编辑</el-button
            >
          </div>
          <div class="info">
            <span class="title">{{ props.data.name }}</span>
            <span class="size">{{ props.data.widthHeight }}</span>
          </div>
        </div>
      </self-carsoursel>
      <share-work
        v-model="shareWorkVisible"
        v-if="shareWorkVisible"
        :shareItem="shareItem"
      >
      </share-work>
    </el-main>
    <el-footer class="m-footer" v-show="items.length">
      <el-pagination
        v-if="items.length"
        @size-change="sizeChange"
        @current-change="currentChange"
        background
        layout="total, sizes, ->, prev, pager, next, jumper"
        :total="totalItems"
        :current-page="param.pageNum"
        :page-sizes="[30, 60, 90, 120]"
        :page-size="param.pageSize"
      >
      </el-pagination>
    </el-footer>
    <el-dialog title="请选择标签" :visible.sync="dialogVisible" width="30%">
      <div class="m-tags">
        <template v-if="tagsList.length > 0">
          <span
            v-for="item in tagsList"
            :key="item.id"
            class="c-tag-item hover"
            :class="{
              'm-selected': activeItemTags.includes(item.id)
            }"
            @click="handleTagClick(item.id)"
            >{{ item.name }}</span
          >
        </template>
        <div style="text-align: center; color: #999;" v-else>
          项目管理员还未配置任何标签
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleComfirm">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import worksService from '../../request/service/works-service'
import selfCarsoursel from '../components/self-carousel'
import top from './components/top'
import noResult from './components/noResult'
import util from '@/util.js'
import shareWork from './components/shareWork-modal'
import routerMixin from '@/mixins/router-mixin.js'
import {
  template_type_multiple,
  template_type_single,
  template_type_ppt,
  template_type_free
} from '@/const.js'
export default {
  components: {
    selfCarsoursel,
    top,
    noResult,
    shareWork
  },
  mixins: [routerMixin],
  props: {
    type: String
  },
  data () {
    return {
      dialogVisible: false,
      items: [],
      tagsList: [],
      activeItemTags: [],
      loading: true,
      loadingDelete: false,
      worksPreview: false,
      shareWorkVisible: false,
      shareItem: null,
      current: 0,
      // selectAll: false,
      selectList: [],
      totalItems: 0,
      searchContent: '',
      param: {
        pageNum: 1,
        pageSize: 30,
        name: '',
        updateTimeStart: '',
        searchTime: '',
        widthHeights: [],
        tagIds: [],
        type: null,
        free: null,
        canCommercial: null
      },
      fileType: 'png'
    }
  },
  created () {
    let query = this.$route.query
    this.param.pageNum = +(query.pageNum || 1)
    this.param.pageSize = +(query.pageSize || 30)
    this.param.name = query.name
    this.param.searchTime = query.searchTime
    this.init()
  },
  watch: {
    selectList: function (val) {
      if (val.length >= this.items.length) {
        this.$refs.top.checkedAll()
      } else {
        this.$refs.top.uncheckedAll()
      }
    },
    items: function (val) {
      if (val.length >= this.selectList.length) {
        this.$refs.top.uncheckedAll()
      } else {
        this.$refs.top.checkedAll()
      }
    },
    type () {
      this.param = {
        pageNum: 1,
        pageSize: 30,
        name: '',
        updateTimeStart: '',
        searchTime: '',
        widthHeights: []
      }
      this.selectList = []
      this.getData()
    },
    projectId (val) {
      if (val) {
        this.param = {
          pageNum: 1,
          pageSize: 30,
          name: '',
          updateTimeStart: '',
          searchTime: '',
          widthHeights: []
        }
        this.$refs.top.reset()
        this.$router.push({ path: this.$route.path })
        this.getData()
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.app.loginUser
    },
    projectId () {
      return this.$store.state.app.projectId
    },
    isNotStudyCP () {
      return !this.$store.getters['app/isStudyCP']
    }
  },
  methods: {
    init () {
      this.getData()
    },
    getData () {
      this.loading = true
      switch (this.param.searchTime) {
        case '1':
          this.param.updateTimeStart = moment(new Date())
            .subtract(7, 'days')
            .format('YYYY-MM-DD HH:mm:ss')
          break
        case '2':
          this.param.updateTimeStart = moment(new Date())
            .subtract(1, 'months')
            .format('YYYY-MM-DD HH:mm:ss')
          break
        case '3':
          this.param.updateTimeStart = moment(new Date())
            .subtract(3, 'months')
            .format('YYYY-MM-DD HH:mm:ss')
          break
        case '4':
          this.param.updateTimeStart = moment(new Date())
            .subtract(6, 'months')
            .format('YYYY-MM-DD HH:mm:ss')
          break
        case '5':
          this.param.updateTimeStart = moment(new Date())
            .subtract(1, 'years')
            .format('YYYY-MM-DD HH:mm:ss')
          break
        default:
          this.param.updateTimeStart = ''
          break
      }
      worksService.getWorkTagList(this.projectId).then(data => {
        this.tagsList = data
      })
      worksService
        .getWorksList(
          Object.assign(
            {},
            this.param,
            this.type === 'my'
              ? { author: this.userInfo.id }
              : { projectId: this.projectId }
          )
        )
        .then(data => {
          this.totalItems = data.total
          let newSelectList = []
          data.list.forEach(item => {
            let findText = item.name.split(this.param.name)
            item.nameShow = findText.join(
              '<span style="color:red">' + this.param.name + '</span>'
            )
            if (
              this.selectList.findIndex(obj => {
                return obj.id === item.id
              }) !== -1
            ) {
              item.check = true
              newSelectList.push(item)
            } else {
              item.check = false
            }
            item.isNameEdit = false
            item.visible1 = false
          })
          this.selectList = newSelectList
          this.searchContent = this.param.name
          this.loading = false
          this.items = data.list
        })
    },
    isTeamTemplate (type) {
      return type === template_type_single // 单图模板
    },
    isPPT (type) {
      return type === template_type_ppt
    },
    isFree (type) {
      return type === template_type_free
    },
    isMulti (type) {
      return type === template_type_multiple
    },
    getWidth () {
      return util.getWidth()
    },
    previewWork (index) {
      this.current = index
      this.worksPreview = true
      let pageName = this.getPageName()
      // if(item.type === template_type_multiple){
      //     this.saveUserAction(pageName, this.ActionType.templateGroup.works.preview.key);
      // }else{
      this.saveUserAction(pageName, this.ActionType.works.preview.key)
      // }
    },
    toggleCheckAll (val) {
      this.selectList = []
      this.items.forEach(item => {
        item.check = val
        if (val) {
          this.selectList.push(item)
        }
      })
      let pageName = this.getPageName()
      this.saveUserAction(pageName, this.ActionType.works.selectAll.key)
    },
    toggleCheck (item) {
      item.check = !item.check
      if (item.check) {
        this.selectList.push(item)
      } else {
        this.selectList.splice(
          this.selectList.findIndex(obj => {
            return item.id === obj.id
          }),
          1
        )
      }
      let pageName = this.getPageName()
      this.saveUserAction(pageName, this.ActionType.works.check.key)
    },
    getPageName () {
      return this.type === 'my'
        ? this.ActionType.works.myWorksName.key
        : this.ActionType.works.teamWorksName.key
    },
    getPreviewName () {
      return this.type === 'my'
        ? this.ActionType.worksPreview.myWorksName.key
        : this.ActionType.worksPreview.teamWorksName.key
    },
    submitSearch (param) {
      // this.param.name = param.name;
      // this.param.searchTime = param.searchTime;
      // this.param.widthHeights = param.widthHeights;
      // this.param.type = param.type;
      // this.param.tagIds = param.tagIds;
      Object.assign(this.param, param, { pageNum: 1 })
      this.getData()
      this.$router.push({ path: this.$route.path, query: this.param })

      let pageName = this.getPageName()
      if (param.widthHeights && param.widthHeights.length > 0) {
        this.saveUserAction(pageName, this.ActionType.works.sizeSearch.key)
      }
      if (param.searchTime) {
        this.saveUserAction(pageName, this.ActionType.works.timeSearch.key)
      }
      if (param.name) {
        this.saveUserAction(pageName, this.ActionType.works.worksNameSearch.key)
      }
    },
    getAllData () {
      this.param.name = ''
      this.param.searchTime = '6'
      this.$refs.top.reset()
      this.$router.push({ path: this.$route.path })
      this.getData()
    },
    exportOneImg (item, fileType) {
      this.exportImg([item.id], fileType)
      let pageName = this.getPageName()
      if (item.type !== template_type_single) {
        this.saveUserAction(
          pageName,
          this.ActionType.works.export.key,
          item.type,
          null,
          item.tplGroupName
        )
      } else {
        this.saveUserAction(
          pageName,
          this.ActionType.works.export.key,
          item.type,
          item.templateId
        )
      }
    },
    exportImgs (fileType) {
      let ids = this.selectList.map(item => {
        return item.id
      })
      this.exportImg(ids, fileType)
      let pageName = this.getPageName()
      this.saveUserAction(pageName, this.ActionType.works.batchExport.key)
      this.selectList.forEach(item => {
        // 记录单个模板导出
        if (item.type !== template_type_single) {
          this.saveUserAction(
            pageName,
            this.ActionType.works.export.key,
            item.type,
            null,
            item.tplGroupName
          )
        } else {
          this.saveUserAction(
            pageName,
            this.ActionType.works.export.key,
            item.type,
            item.templateId
          )
        }
      })
    },
    exportImgsForPreview (item) {
      // console.log(123123, item)
      this.exportImg([item.id], this.fileType)
      let pageName = this.getPreviewName()
      if (item.type !== template_type_single) {
        this.saveUserAction(
          pageName,
          this.ActionType.worksPreview.export.key,
          item.type,
          null,
          item.tplGroupName
        )
      } else {
        this.saveUserAction(
          pageName,
          this.ActionType.worksPreview.export.key,
          item.type,
          item.templateId
        )
      }
    },
    exportImg (ids, fileType) {
      //导出列表
      worksService
        .exportWorks(ids, fileType)
        .then(res => {
          this.download(res)
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '导出失败',
            showClose: true
          })
        })
    },
    download (res) {
      let url = window.URL.createObjectURL(res.data)
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', this.getFileName(res.headers))
      document.body.appendChild(link)
      link.click()
    },
    getFileName (headers) {
      let name = headers['content-disposition']
        .split(';')[1]
        .split('=')[1]
        .split('.')
      return decodeURI(name[0]) + '.' + name[1]
    },
    deleteOneWork (item) {
      this.deleteWorks(item)
      let pageName = this.getPageName()

      // if(item.type === template_type_multiple){
      //     this.saveUserAction(pageName, this.ActionType.templateGroup.works.delWorks.key);
      // } else {
      this.saveUserAction(pageName, this.ActionType.works.delWorks.key)
      // }
    },
    deleteMoreWorks (array) {
      this.loadingDelete = true
      this.deleteWorks(array)
      let pageName = this.getPageName()
      this.saveUserAction(pageName, this.ActionType.works.batchDelWorks.key)
    },
    deleteWorks (item) {
      let items
      if (item && item.id) {
        items = [item.id]
      } else {
        items = this.selectList.map(obj => {
          return obj.id
        })
      }
      worksService
        .deleteWorks(items)
        .then(() => {
          this.getData()
          this.$message({
            type: 'success',
            message: '删除成功',
            showClose: true
          })
          let idx = this.selectList.findIndex(obj => {
            return obj.id === item.id
          })
          if (item && idx > -1) {
            this.selectList.splice(idx, 1)
          }
        })
        .catch(() => {
          console.log('删除失败')
        })
        .finally(() => {
          this.loadingDelete = false
        })
    },
    // 标签分类
    handleTagWork (item) {
      this.activeItemTags = item.workTagIds || []
      this.activeItemId = item.id
      this.dialogVisible = true
    },
    handleComfirm () {
      if (this.tagsList.length === 0) {
        this.dialogVisible = false
        return
      }
      const tagNames = this.tagsList
        .filter(item => this.activeItemTags.includes(item.id))
        .map(item => item.name)
      worksService
        .setWorkTags(this.projectId, {
          workId: this.activeItemId,
          tagNames
        })
        .then(() => {
          this.$message.success('修改成功')
          this.dialogVisible = false
        })
        .catch(e => this.$message.error('修改失败'))
    },
    handleCancel () {
      this.dialogVisible = false
    },
    handleTagClick (id) {
      if (this.activeItemTags.includes(id)) {
        this.activeItemTags.splice(this.activeItemTags.indexOf(id), 1)
      } else {
        this.activeItemTags.push(id)
      }
    },
    copyUrl (item) {
      const input = document.createElement('input')
      // this.menuVisible = false;
      document.body.appendChild(input)
      let url = window.location.origin + '/#/works/' + item.id + '/editor'
      if (item.type === template_type_free) {
        url = window.location.origin + '/#/workFree/' + item.id + '/editor'
      } else if (item.type !== template_type_single) {
        url = window.location.origin + '/#/workGroup/' + item.id + '/editor'
      }
      input.setAttribute('value', url)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$message({
          type: 'success',
          message: '图片地址复制成功，请将地址黏贴到你需要的地方',
          showClose: true
        })
      }
      document.body.removeChild(input)
      let pageName = this.getPageName()
      this.saveUserAction(pageName, this.ActionType.works.copyLink.key)
    },
    copyWork (item) {
      worksService
        .copyWorks({ workId: item.id, projectId: item.projectId })
        .then(() => {
          this.getData()
          this.$message({
            type: 'success',
            message: '复制成功',
            showClose: true
          })
        })
      let pageName = this.getPageName()
      // if(item.type === template_type_multiple){
      //     this.saveUserAction(pageName, this.ActionType.templateGroup.works.copyWorks.key);
      // }else{
      this.saveUserAction(pageName, this.ActionType.works.copyWorks.key)
      // }
    },
    sizeChange (size) {
      this.param.pageSize = size
      this.$router.push({ path: this.$route.path, query: this.param })
      this.getData()
    },
    currentChange (num) {
      this.param.pageNum = num
      this.$router.push({ path: this.$route.path, query: this.param })
      this.getData()
    },
    clickout (item, index) {
      item.isNameEdit = false
      let newName = this.$refs['editArea' + index][0].value
      worksService
        .rename({ id: item.id, name: newName })
        .then(() => {
          item.nameShow = newName
          item.name = newName
        })
        .catch(data => {
          console.log(data)
        })
    },
    editName (item, index) {
      item.isNameEdit = true
      this.$nextTick(() => {
        this.$refs['editArea' + index][0].focus()
      })
      let pageName = this.getPageName()
      this.saveUserAction(pageName, this.ActionType.works.editName.key)
    },
    editWorkOnPreview (item) {
      this.editWork(item)
      let pageName = this.getPreviewName()
      if (item.type !== template_type_single) {
        this.saveUserAction(
          pageName,
          this.ActionType.templateGroup.works.editWorks.key,
          item.type,
          null,
          item.tplGroupName
        )
      } else {
        this.saveUserAction(
          pageName,
          this.ActionType.worksPreview.goToEditor.key,
          item.type,
          item.templateId
        )
      }
    },
    editWorkOnImg (item) {
      this.editWork(item)
      let pageName = this.getPageName()
      if (item.type !== template_type_single) {
        this.saveUserAction(
          pageName,
          this.ActionType.templateGroup.works.editWorks.key,
          item.type,
          null,
          item.tplGroupName
        )
      } else {
        this.saveUserAction(
          pageName,
          this.ActionType.works.goToEditor.key,
          item.type,
          item.templateId
        )
      }
    },
    getRouterLink (type, id, free) {
      if (free) {
        return `/workFree/${id}/editor`
      }
      let obj = {}
      obj[template_type_single] = `/works/${id}/editor`
      obj[template_type_multiple] = `/workGroup/${id}/editor`
      obj[template_type_ppt] = `/workGroup/${id}/editor`
      return obj[type]
    },
    editWork (item) {
      let id = item.id
      let query = this.$route.path.startsWith('/works/team') ? 'team' : 'my'
      let url = this.getRouterLink(item.type, id, item.free)
      const workRouter = this.$router.resolve({
        path: url,
        param: {
          id: id
        },
        query: {
          type: query
        }
      })
      window.open(workRouter.href, '_blank')
    },
    shareWork (item) {
      this.shareItem = item
      this.shareWorkVisible = true
      let pageName = this.getPageName()
      // if(item.type === template_type_multiple){
      //     this.saveUserAction(pageName, this.ActionType.templateGroup.works.shareWorks.key);
      // }else{
      this.saveUserAction(pageName, this.ActionType.works.shareWorks.key)
      // }
    },
    onSwitchPng () {
      let pageName = this.getPreviewName()
      this.saveUserAction(pageName, this.ActionType.works.switch.key)
    },
    getListStyle () {
      let w = util.getWidthNum(),
        tplW = 220
      let margin = w - Math.floor(w / tplW) * tplW
      return `margin-left: ${margin / 2}px;`
    }
  }
}
</script>

<style lang="scss">
@import './works.scss';
</style>
